module.exports = __webpack_public_path__ + "static/img/06.d105ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20241216_2/06.png
// module id = SjxY
// module chunks = 0